export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentcolor" d="M15.886 3.21a.818.818 0 0 1 1.095 1.217L8.564 12l8.415 7.574a.818.818 0 0 1-1.094 1.216L7.17 12.946a1.273 1.273 0 0 1 0-1.893l8.716-7.843Z"/>
</svg>
`;
